import 'pusher-js';
import Vue from 'vue';
import Echo from 'laravel-echo';

Vue.prototype.$echo = new Echo({
  broadcaster: 'pusher',
  key: window.appConfig.pusher.key,
  cluster: window.appConfig.pusher.cluster,
  forceTLS: window.appConfig.pusher.useTLS,
});
